/* Flurr blog (T-037): turns each article's FAQ block into one accordion design, places the author row and builds the contents list.
   Without JavaScript the article keeps its plain headings and paragraphs. */
(function () {
  var content = document.querySelector('.blog-post-detail .post-content');
  if (!content) { return; }

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  // Author row: move it from below the article to just under the title.
  var authorRow = document.querySelector('.flurr-author');
  var titleBlock = document.querySelector('.blog-post-detail .post-title');
  if (authorRow && titleBlock) {
    authorRow.classList.remove('page-content-width');
    authorRow.classList.add('flurr-author--top');
    titleBlock.appendChild(authorRow);
  }

  // Sidebar "In this article": one entry per h2, shown when there are at least 3.
  var toc = document.querySelector('.flurr-toc');
  if (toc) {
    var sections = content.querySelectorAll('h2');
    var list = toc.querySelector('ol');
    if (sections.length >= 3 && list) {
      for (var s = 0; s < sections.length; s++) {
        if (!sections[s].id) { sections[s].id = 'section-' + (s + 1); }
        var entry = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + sections[s].id;
        link.textContent = text(sections[s]);
        entry.appendChild(link);
        list.appendChild(entry);
      }
      toc.hidden = false;
    }
  }

  // FAQ: find the FAQ heading, then group each question with its answer.
  var heads = content.querySelectorAll('h1, h2, h3, h4, h5, h6, p');
  var head = null;
  for (var i = heads.length - 1; i >= 0; i--) {
    var t = text(heads[i]);
    if (t.length <= 90 && /^(faqs?\b|frequently asked questions)/i.test(t)) { head = heads[i]; break; }
  }
  if (!head) { return; }
  var parent = head.parentNode;
  // A heading and the first question pasted into one tag, split by a line break.
  var pieces = head.innerHTML.split(/<br\s*\/?>/i);
  if (pieces.length > 1) {
    var probe = document.createElement('div');
    probe.innerHTML = pieces.slice(1).join(' ');
    if (/\?$/.test(text(probe))) {
      head.innerHTML = pieces[0];
      var firstQuestion = document.createElement('h3');
      firstQuestion.textContent = text(probe);
      parent.insertBefore(firstQuestion, head.nextSibling);
    }
  }
  var kids = Array.prototype.slice.call(parent.children);
  var start = kids.indexOf(head);

  // Returns {q: question text, rest: answer node or null} when el opens a question.
  function question(el) {
    var t = text(el);
    if (/^H[2-6]$/.test(el.tagName)) { return /\?$/.test(t) && t.length <= 200 ? { q: t, rest: null } : null; }
    if (el.tagName !== 'P') { return null; }
    var first = el.firstElementChild;
    if (!first || !/^(STRONG|B)$/.test(first.tagName) || text(el).indexOf(text(first)) !== 0) { return null; }
    var q = text(first);
    if (!/\?$/.test(q) || q.length > 200) { return null; }
    if (q === t) { return { q: q, rest: null }; }
    var rest = el.cloneNode(true);
    rest.removeChild(rest.firstElementChild);
    while (rest.firstChild && (rest.firstChild.nodeName === 'BR' || !text(rest.firstChild))) { rest.removeChild(rest.firstChild); }
    return { q: q, rest: rest };
  }

  var wrap = document.createElement('div');
  wrap.className = 'flurr-faq';
  var answer = null;
  var count = 0;
  for (var j = start + 1; j < kids.length; j++) {
    var el = kids[j];
    var found = question(el);
    if (found) {
      if (!count) { parent.insertBefore(wrap, el); }
      var item = document.createElement('details');
      item.className = 'flurr-faq__item';
      if (!count) { item.open = true; }
      var summary = document.createElement('summary');
      summary.textContent = found.q.replace(/^Q\d*[.:)]\s*/i, '');
      answer = document.createElement('div');
      answer.className = 'flurr-faq__answer';
      if (found.rest) { answer.appendChild(found.rest); }
      item.appendChild(summary);
      item.appendChild(answer);
      wrap.appendChild(item);
      parent.removeChild(el);
      count++;
      continue;
    }
    if (/^H[1-6]$/.test(el.tagName) || el.tagName === 'DETAILS' || el.tagName === 'STYLE') { break; }
    if (!count) { continue; }
    if (el.tagName === 'HR') { parent.removeChild(el); continue; }
    answer.appendChild(el);
  }
  if (count) { head.classList.add('flurr-faq__title'); }
})();
